module.exports = __webpack_public_path__ + "static/images/recipient-single.21O68Hz.svg";